import React, { useMemo } from "react";
import { Helmet } from 'react-helmet-async';
import NewsCard from "../component/NewsCard";
import "./NewsSection.css";

const NewsSection = ({ posts = [], onSelectPost, facebookUrl }) => {

  const postCards = useMemo(() => {
    if (posts.length === 0) {
      return (
        <div className="no-news-container">
          <p className="no-news">Brak aktualności do wyświetlenia.</p>
          {facebookUrl && (
            <a 
              href={facebookUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              className="facebook-profile-link"
            >
              <svg className="facebook-icon" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
              Zobacz profil parafii na Facebooku
            </a>
          )}
        </div>
      );
    }
    
    return posts.map((post, index) => (
      <NewsCard
        key={post.id || index} 
        post={post}
        onClick={() => onSelectPost?.(post)}
      />
    ));
  }, [posts, onSelectPost, facebookUrl]);

  const getMetaDescription = () => {
    if (posts.length === 0) {
      return "Najnowsze aktualności i ogłoszenia z parafii św. Urszuli Ledóchowskiej w Częstochowie. Sprawdź wydarzenia, komunikaty i informacje dla parafian.";
    }
    
    const latestPosts = posts.slice(0, 3);
    const postTitles = latestPosts.map(post => post.title || post.message?.substring(0, 50) || 'Aktualność').join(', ');
    const postCount = posts.length;
    
    return `Aktualności parafialne (${postCount} najnowsze): ${postTitles}. Sprawdź najświeższe informacje z parafii św. Urszuli Ledóchowskiej w Częstochowie.`;
  };

  const getLatestImage = () => {
    const latestPost = posts.find(post => post.picture && post.picture !== "/assets/urszula_logo.png");
    return latestPost?.picture || "/assets/urszula_photo.png";
  };

  return (
    <>
      <Helmet>
        <title>Aktualności – Parafia św. Urszuli Ledóchowskiej w Częstochowie</title>
        <meta name="description" content={getMetaDescription()} />
        <meta name="keywords" content="aktualności, ogłoszenia parafialne, wydarzenia, komunikaty, parafia Częstochowa, św. Urszula Ledóchowska, Wrzosowiak, triduum, nabożeństwa" />
        <meta property="og:title" content="Aktualności – Parafia św. Urszuli Ledóchowskiej" />
        <meta property="og:description" content={getMetaDescription()} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://swurszula.pl/" />
        <meta property="og:image" content={getLatestImage()} />
        <meta property="og:image:alt" content="Parafia św. Urszuli Ledóchowskiej w Częstochowie" />
        <meta property="og:locale" content="pl_PL" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aktualności – Parafia św. Urszuli Ledóchowskiej" />
        <meta name="twitter:description" content={getMetaDescription()} />
        <meta name="twitter:image" content={getLatestImage()} />
      </Helmet>

      <section>
        <h2 className="section-title">Aktualności</h2>
        <div className="newsContainer">
          {postCards}
        </div>
      </section>
    </>
  );
};

export default React.memo(NewsSection);